import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	clearFiltersLabel: {
		id: 'software-code-code-page.pages.main-page.pull-requests.pull-request-list.filters.clear-filters-label',
		defaultMessage: 'Clear filters',
		description:
			'Label associated to the button allowing to clear the filters for the Pull Requests table',
	},
});
